import React from "react";
import { notification, message } from "antd";
import swal from "sweetalert";

export const openNotification = (title, message, type) => {
  notification[type]({
    message: (
      <div style={{ color: type === "error" ? "green" : "black" }}>{title}</div>
    ),
    description: (
      <div style={{ color: type === "error" ? "green" : "black" }}>
        {message}
      </div>
    ),
    style: { backgroundColor: type === "error" ? "red" : "#f5e18e" },
    duration: 0,
  });
};

export const swalLoginNotification = (title, message, type) => {
  swal({
    title: title,
    text: message,
    icon: type,
    button: "Ok",
  }).then(function () {
    window.location = "/rider";
  });
};

export const swalNotification = (title, message, type) => {
  swal({
    title: title,
    text: message,
    icon: type,
    button: "Ok",
  });
};


export const successAlert = (text) => {
  message.success(text)
}